import { useState, useEffect } from 'react'
import { buildMapboxStaticUrl, fetchMapboxImage } from './mapbox-static-api'

export const useMapImage = (climate) => {
  const [mapUrl, setMapUrl] = useState(null)
  const [imageDimensions, setImageDimensions] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const lat = climate?.lat
  const lng = climate?.lng
  const zoom = climate?.zoom

  useEffect(() => {
    async function loadImage() {
      if (lat == null || lng == null || zoom == null) {
        setMapUrl(null)
        setImageDimensions(null)
        setLoading(false)
        setError(null)
        return
      }

      setLoading(true)
      setError(null)

      try {
        const url = buildMapboxStaticUrl(lng, lat, zoom)
        const { objectUrl, width, height } = await fetchMapboxImage(url)
        setMapUrl(objectUrl)
        setImageDimensions({ width, height })
      } catch (err) {
        console.error('Error loading map image:', err.message)
        setError(err.message)
        setMapUrl(null)
        setImageDimensions(null)
      } finally {
        setLoading(false)
      }
    }

    loadImage()
  }, [lat, lng, zoom])

  return { mapUrl, imageDimensions, loading, error }
}
